import { Autocomplete, Backdrop, Button, Dialog, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CustomTable from "../../reports/customTable";
import WHDamageModal from "./whModel";
// import { useNavigate } from "react-router-dom";

const WhDamageReport = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [supplier, setSupplier] = useState([]);
  // const navigate = useNavigate();
  const [salesLines, setSalesLines] = useState([]);
  const [open, setOpen] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalFlag, setTotalFlag] = useState(false);
  const roleId = localStorage.getItem("role_id");
  const outletName = localStorage.getItem('outlet_name');
  const outletId = localStorage.getItem('outlet_id');
  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().format(),
    toDate: moment().format(),
  });
  const [cust, setCust] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [docNo, setDocNo] = useState('');
  const [activeId, setActiveId] = useState(null);
  const [selectedDocNo, setSelectedDocNo] = useState(null);
  const fixedOutlet = { id: outletId, fullname: outletName };

  const onEdit = (e) => {
    setSalesLines(e.row.outletWastage_lines);
    setRowData(e.row);
    setOpen(true);
  };

  const columns = [
    { field: 'sno', headerName: 'S.no', minWidth: 100, headerAlign: 'center', align: 'center', sortable: false },
    { field: "docno", headerName: "Doc No", minWidth: 250, headerAlign: "center", align: "center", sortable: false },
    { field: "date1", headerName: "Date", minWidth: 230, headerAlign: "center", align: "center", sortable: false },
    { field: "amount", headerName: "Amount", minWidth: 100, headerAlign: "center", align: "center", sortable: false },
    { field: "totalqty", headerName: "Total Qty", minWidth: 180, headerAlign: "center", align: "center", sortable: false },
    {
      field: "status",
      headerName: "Status",
      minWidth: 160,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        params.row.is_approved === 1 ? "Approved" : "Un Approved"
      ),
    },
    {
      field: "view",
      headerName: "View",
      minWidth: 130,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableExport: true,
      renderCell: (params) => (
        <IconButton size="small" onClick={() => onEdit(params)}><VisibilityIcon /></IconButton>
      ),
    },
  ];

  const rows = data.map((val, idx) => ({
    id: val.id,
    sno: idx + 1,
    date1: moment(val.date).format("DD-MM-YYYY"),
    docno: val.docno,
    totalqty: val.totalqty,
    amount: val.amount,
    outletWastage_lines: val.outletWastage_lines,
    is_approved: val.is_approved,
    documentDate: moment(val.date).format("DD-MM-YYYY"),
    outlet_id: val?.outlet_id,
  }));

  const props = {
    columns: columns,
    rows: rows,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
    totalAmount: totalAmount,
    totalFlag: totalFlag,
  };

  useEffect(() => {
    setTotalFlag(true);
    let total = 0;
    data.forEach(val => {
      total += parseFloat(val.amount);
    });
    setTotalAmount(total.toFixed(2));
  }, [data]);

  const tableHeadData = [
    { id: 1, label: "S No" },
    { id: 2, label: "Doc No" },
    { id: 3, label: "Date" },
    { id: 4, label: "Po Name" },
    { id: 5, label: "Barcode" },
    { id: 6, label: "Amount" },
    { id: 7, label: "Rate" },
    { id: 8, label: "Qty" },
  ];

  const tableBodyData = salesLines.map((val, idx) => ({
    id: idx,
    sNo: idx + 1,
    docno: val?.docno,
    date: val?.date,
    proName: val?.pro_name,
    pro_code: val?.pro_code,
    qty: val?.qty,
    date: moment(val.date).format("YYYY-MM-DD"),
    purchase_rate: val?.purchase_rate,
    order_qty: val?.order_qty,
    amount: val?.amount,
    barcode: val?.barcode,
    prodid: val?.prodid,
    total_gst: val?.total_gst,
    rate: val?.rate,
    is_approved: val?.is_approved,
  }));

  function handleChange(e, name) {
    setDateLimit(prev => ({ ...prev, [name]: dayjs(e).format() }));
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        setSupplier(res.data);
        res.data.filter(val => val.id == outletId).forEach(val => setCust(val));
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function handleDamageReportFetch() {
    if (!dateLimit || !dateLimit.fromDate || !dateLimit.toDate || !cust?.id) {
      console.error("Missing required fields");
      return;
    }
    const fromDate = moment(dateLimit.fromDate).format('YYYY-MM-DD');
    const toDate = moment(dateLimit.toDate).format('YYYY-MM-DD');
    const url = `/v1/wastage/outlet/fetch/${rowsPerPage}/${page}?from_date=${fromDate}&to_date=${toDate}&outlet_id=${cust.id}${docNo ? `&docno=${docNo}` : ""}`;
    axios
      .get(url)
      .then(res => {
        const responseData = res.data.data || [];
        setData(responseData);
        setPageCount(res.data.meta?.pagination?.total_pages || 0);
        setSalesLines(responseData.length ? responseData[0].outletWastage_lines : []);
      })
      .catch((err) => {
        console.error(err);
        setData([]);
      });
  }
  useEffect(() => { getSupplierData(); }, []);
  useEffect(() => {
    if (dateLimit.fromDate !== null && dateLimit.toDate !== null) {
      handleDamageReportFetch();
    }
  }, [rowsPerPage, page, dateLimit, cust, docNo]);

  return (
    <Fragment>
      <Helmet><title> Damage Reports</title></Helmet>
      <Typography variant="h6">WareHouse Closing Stock Damage Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete
            size="small"
            value={cust}
            options={supplier}
            onChange={(e, value) => setCust(value)}
            getOptionLabel={option => option.fullname}
            // disabled={roleId != 1 && roleId != 2}
            renderInput={(params) => <TextField {...params} label="Select Outlet" />}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              // disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label: 'From',
                  style: { width: '100%' }
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              // disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label: 'To',
                  style: { width: '100%' }
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props} />
      <Backdrop open={open} sx={{ zIndex: 1300 }}>
        <WHDamageModal
          cust={cust}
          setSelectedRow={setSelectedRow}
          setOpenDialog={setOpenDialog}
          tableHeadData={tableHeadData}
          flattenedData={tableBodyData}
          tableBodyData={tableBodyData}
          setOpen={setOpen}
          data={rowData}
          sx={{ zIndex: 1350 }}
        />
      </Backdrop>
    </Fragment>
  );
};

export default memo(WhDamageReport);
